import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred';

      // ✅ Fix: Guard against SSR where ErrorEvent is not defined
      if (typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = `Client Error: ${error.error.message}`;
      } else {
        // Server-side error
        switch (error.status) {
          case 400:
            // Use the exact error message from backend if available
            errorMessage = (error.error as any)?.message || 'Bad Request: Please check your input';
            break;
          case 401:
            // Don't automatically logout on 401 - let auth interceptor handle token refresh
            // Only logout if it's a refresh endpoint (refresh failed)
            if (req.url.includes('/auth/refresh')) {
              errorMessage = 'Session expired: Please login again';
              authService.logout().subscribe(() => {
                setTimeout(() => window.location.href = 'https://app.messagefromheaven.com', 0);
              });
            } else {
              errorMessage = 'Unauthorized: Please login again';
            }
            break;
          case 403:
            // Prefer backend message if provided
            errorMessage =
              (error.error as any)?.message ||
              (error.error as any)?.error ||
              'Forbidden: You do not have permission to access this resource';
            break;
          case 404:
            errorMessage = 'Not Found: The requested resource was not found';
            break;
          case 500:
            errorMessage = 'Internal Server Error: Please try again later';
            break;
          case 503:
            errorMessage = 'Service Unavailable: Please try again later';
            break;
          default:
            errorMessage = `Server Error: ${error.status} - ${error.message}`;
        }
      }

      // Log error for debugging

      // Preserve the original error structure for 400 errors so components can access error.error.message
      if (error.status === 400) {
        // Return the original error structure so error.error.message is accessible
        return throwError(() => error);
      }
      
      // For other errors, preserve structure but add message
      const enhancedError = {
        ...error,
        message: errorMessage
      };
      return throwError(() => enhancedError);
    })
  );
};
